import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


declare function Getapiurl():any;

@Injectable()
export class AuthService {
    public token: string;
    public username: string;
   //public callurl:string='http://43.247.158.94:8081/mycampz_test/v3/index.php';
   public callurl:string;

   
  constructor(private http: HttpClient,private _global: AppGlobals) {
      debugger
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
    //this.seturi();
    this.callurl=_global.baseAPIUrl;
   // this.callurl=dataurl.baseUrl;
  }
  public getJSON(): Observable<any> {
    return this.http.get("./assets/config.json");
}
login(userData: any): Observable<boolean> {
    return this.http.post( this.callurl+'login', userData)
        .pipe(map((data: any) => {
            // login successful if there's a jwt token in the response
            let token = data && data.token;
            let unm = data && data.username;
            let photo = data && data.photo;
            if (token) {
                // set token property
                this.token = token;
                console.log('usrdata',data);
                // store username and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify({ username: unm, token: token,photo:photo }));
                localStorage.setItem('token', token);
                localStorage.setItem('clcd', data.clcd);
                localStorage.setItem('aycd', data.ayid);
                localStorage.setItem('clnm', data.clnm);
                localStorage.setItem('usrname', data.username);
                localStorage.setItem('usid', data.usid);
                localStorage.setItem('insid', data.insid);
                localStorage.setItem('masclid', data.masclid);
                localStorage.setItem('instype', data.instype);
                localStorage.setItem('role', data.role);
                localStorage.setItem('rts', data.rts);
                localStorage.setItem('softtype', data.softtype);
                

                // return true to indicate successful login
                return true;
            } else {
                // return false to indicate failed login
                console.log('data',data);
                return false;
            }
        }));
}
logout() {
    // remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('clcd');
    localStorage.removeItem('aycd');
    localStorage.removeItem('clnm');
    localStorage.removeItem('usrname');
    localStorage.removeItem('usid');
    localStorage.removeItem('role');
    localStorage.clear();
}



 modulesList(){
  
  console.log('modulecallurl',this.callurl);
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
  let role=localStorage.getItem('role');
  console.log('modulecallurl',role);
  return this.http.get( this.callurl+'modules/'+clcd+'/'+aycd+'/'+role)
      .pipe(map((data: any) => {
        return data.data;
      })	);
  }


getayyear() {
    debugger
//  var call= this.seturi();
//  console.log('url',call);
  return this.http.get(this.callurl + 'Aylist')
      .pipe(map((data: any) => {
          return data.aylist;
      }))
}

public getToken(): string {
    return localStorage.getItem('token');
  }

  getroles(oprtype) {
    debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),oprtype:oprtype};
  return this.http.post(this.callurl + 'getsecroles',pstdata)
      .pipe(map((data: any) => {
          return data.roles;
      }))
}


getuserlog(frdt,todt) {
  debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),frdt:frdt,todt:todt};
return this.http.post(this.callurl + 'getuserlogs',pstdata)
    .pipe(map((data: any) => {
      console.log(data);
        return data.userlogs;
    }))
}


getmycplog() {
  debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd')};
return this.http.post(this.callurl + 'getmycplog',pstdata)
    .pipe(map((data: any) => {
      console.log(data);
        return data.userlogs;
    }))
}


getroleaccessdet(roleid) {
  debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),roleid:roleid};
return this.http.post(this.callurl + 'getroleaccessdtls',pstdata)
    .pipe(map((data: any) => {
         return data.roleaccessdtls;
        //return data;
    }))
}


saverole(roledata: any): Observable<any> {

  roledata.clcd=localStorage.getItem('clcd');
  roledata.aycd=localStorage.getItem('aycd');
  roledata.softtype=localStorage.getItem('softtype');
  console.log('pstdata',roledata);
  return this.http.post(this._global.baseAPIUrl + 'savesecrole', roledata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

updatepermission(roledata: any): Observable<any> {

  roledata.clcd=localStorage.getItem('clcd');
  roledata.aycd=localStorage.getItem('aycd');
  roledata.oprtype='updper';
  console.log('pstdata',roledata);
  return this.http.post(this._global.baseAPIUrl + 'updatepermissions', roledata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

updatestatus(roledata: any,staus): Observable<any> {

  roledata.clcd=localStorage.getItem('clcd');
  roledata.aycd=localStorage.getItem('aycd');
  roledata.oprtype='updstatus';
  roledata.recordstatus=staus;
  console.log('pstdata',roledata);
  return this.http.post(this._global.baseAPIUrl + 'updatepermissions', roledata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

  getdatetoday()
  {
   let d: Date = new Date();
   var mnth='';
   var day='';
   //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
   if(d.getMonth()>=10)
   {
     mnth=d.getMonth().toString();
   }
   else{
     mnth='0'+d.getMonth();
   }

   if(d.getDate()>=10)
   {
     day=d.getDate().toString();
   }
   else{
     day='0'+d.getDate();
   }
   let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
     
return todayDate;

  }


  getsysdatetoday()
  {
   return this.http.get(this.callurl + 'getsysdate')
   .pipe(map((data: any) => {
           console.log('retres', data);
           return data;
       }));

  }

  getmnugrp() {
    debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd')};
  return this.http.post(this.callurl + 'getmnugroup',pstdata)
      .pipe(map((data: any) => {
          return data.mnugrplst;
      }))
}


getmnulist(gpid) {
  debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),mgpid:gpid};
return this.http.post(this.callurl + 'getmnulist',pstdata)
    .pipe(map((data: any) => {
        return data.mnulst;
    }))
}


getmnulink(gpid,rlid) {
  debugger
//  var call= this.seturi();
//  console.log('url',call);
var pstdata={clcd:localStorage.getItem('clcd'),aycd:localStorage.getItem('aycd'),mgpid:gpid,roleid:rlid};
return this.http.post(this.callurl + 'getmnulinks',pstdata)
    .pipe(map((data: any) => {
        return data.mnulst;
    }))
}


allocatemenu(roledata: any): Observable<any> {

  
  console.log('pstdata',roledata);
  return this.http.post(this._global.baseAPIUrl + 'allocatemenu', roledata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

}
